export class PromiseExecutorQueue {
    private requestInProgress: Promise<void>;
    constructor() {
        this.requestInProgress = Promise.resolve();
    }

    public runActionInQue(action: () => Promise<void>) {
        const prevAction = this.requestInProgress;

        this.requestInProgress = (async (): Promise<void> => {
            try {
                await prevAction;
            } catch (error) {
                console.error(error);
            }

            await action();
        })();
    }
}
